import type {
  PreferredTablesResponse,
  PutPreferredTablesRequest,
} from '@swiss-magic/shared-types';
import { get, put } from './core';

// Story 106 — preferred table numbers. Full-list replace; array order is the
// priority order (index 0 = top = highest priority).

export function getPreferredTables(
  tournamentId: string,
): Promise<PreferredTablesResponse> {
  return get(`/tournaments/${tournamentId}/preferred-tables`);
}

export function putPreferredTables(
  tournamentId: string,
  body: PutPreferredTablesRequest,
): Promise<PreferredTablesResponse> {
  return put(`/tournaments/${tournamentId}/preferred-tables`, body);
}
